import { useState } from 'react';

export const useConstructor = callback => {
	const [hasRun, setHasRun] = useState(false);

	if (!hasRun) {
		callback();
		setHasRun(true);
	}
};
